import React, { useState, useEffect } from "react";

export default function AlertIcon({ type }) {
  const [alertType, setAlertType] = useState("");
  useEffect(() => {
    setAlertType(type);
  }, [type]);

  return (
    <div>
      {type === "success" && (
        <div className="alert-icon alert-icon--success">
          <span className="alert-icon--success__line alert-icon--success__line--long"></span>
          <span className="alert-icon--success__line alert-icon--success__line--tip"></span>
          <div className="alert-icon--success__ring"></div>
          <div className="alert-icon--success__hide-corners"></div>
        </div>
      )}
      {type === "error" && (
        <div className="alert-icon alert-icon--error">
          <div className="alert-icon--error____x-mark">
            <span className="alert-icon--error__line alert-icon--error__line--left"></span>
            <span className="alert-icon--error__line alert-icon--error__line--right"></span>
          </div>
        </div>
      )}
    </div>
  );
}
